import React from 'react';
import * as Logger from '../../services/logger';
import { ErrorPageWrapper } from './ErrorPageWrapper';

interface ErrorBoundaryState {
  error?: any;
  errorInfo?: React.ErrorInfo;
}

export class ErrorBoundary extends React.Component<{}, ErrorBoundaryState> {
  constructor(props) {
    super(props);
    this.state = {
      error: undefined,
      errorInfo: undefined,
    };
  }

  async componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
    });
    await Logger.logError(error.toString(), errorInfo.componentStack);
  }

  render() {
    const errorMessage = this.state.error
      ? `${this.state.error.toString()}. `
      : '';
    const errorStack = this.state.errorInfo
      ? `Thrown ${this.state.errorInfo.componentStack}.`
      : '';

    return this.state.errorInfo ? (
      <ErrorPageWrapper
        errorType={'generic'}
        description={`${errorMessage}${errorStack}`}
      />
    ) : (
      this.props.children
    );
  }
}
